import { normalizeValue } from './normalizeValue';

export function replaceTokens(
	equation: string | undefined,
	tokens?: Record<string, string | undefined>,
): string | undefined {
	let replaced = normalizeValue(equation);
	if (!replaced?.length) {
		return replaced;
	}
	// No tokens to replace
	if (!tokens) {
		return replaced;
	}

	// Sort the list so that the longest strings come first
	// This avoids issues if we have a token that's a substring of another token
	const tokenEntries = Object.entries(tokens);
	tokenEntries.sort(([keyA], [keyB]) => keyB?.length - keyA?.length);

	for (const [tokenName, tokenValue] of tokenEntries) {
		// If a value is undefined, replace with empty string
		const replacementValue = tokenValue ?? '';
		replaced = replaced.replaceAll(tokenName, replacementValue);
	}

	return replaced;
}
